import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import Footer from "../inc/Footer";
import { path } from "../../../utils";
import "./Term.scss";
import Header from "../inc/Header";
class Term extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    let { language } = this.props;
    return (
      <>
        <Header />
        {language === "vi" ? (
          <div className="container term">
            <div className="intro">
              <h2>CHÍNH SÁCH & ĐIỀU KHOẢN DỊCH VỤ</h2>
              <p>Áp dụng cho tất cả khách hàng tại Việt Nam</p>
              <p>
                Công ty TNHH Hải Phước - Nhà phân phối chính thức thiết bị phân
                tích cơ thể Anovator A5
              </p>
            </div>
            <h2>MỤC 4 - ĐIỀU KHOẢN DỊCH VỤ</h2>
            <p>
              ⚖️ <strong>Giao dịch minh bạch – Trách nhiệm rõ ràng</strong>
            </p>
            <p>
              Khi truy cập website hoặc mua sản phẩm từ chúng tôi, bạn đồng ý
              với các điều khoản sau:
            </p>

            <h4>📝 Quy định giao dịch:</h4>
            <ul>
              <li>
                Đơn hàng hợp lệ khi bạn điền đầy đủ thông tin và thanh toán
                thành công
              </li>
              <li>
                Chúng tôi có quyền hủy đơn nếu phát hiện thông tin sai lệch,
                gian lận hoặc vi phạm chính sách
              </li>
            </ul>

            <h4>🛠️ Sử dụng sản phẩm:</h4>
            <ul>
              <li>
                Hãy làm theo <strong>Hướng dẫn sử dụng</strong> được cung cấp để
                đảm bảo an toàn và hiệu quả
              </li>
              <li>
                Không tự ý tháo mở hoặc can thiệp kỹ thuật – điều này có thể làm
                mất quyền bảo hành
              </li>
            </ul>

            <h4>🔧 Cam kết của chúng tôi:</h4>
            <ul>
              <li>
                Cung cấp <strong>sản phẩm chính hãng</strong>, đầy đủ giấy tờ,
                bảo hành toàn quốc
              </li>
              <li>
                Hỗ trợ kỹ thuật tận tâm <strong>trước – trong – sau</strong> khi
                mua
              </li>
              <li>
                Xử lý khiếu nại minh bạch, dựa trên nguyên tắc{" "}
                <strong>đôi bên cùng có lợi</strong>
              </li>
            </ul>
            <div className="contact-info support">
              <h2>THÔNG TIN LIÊN HỆ HỖ TRỢ</h2>
              <p>
                Công ty TNHH Hải Phước – Nhà phân phối Anovator chính thức tại
                Việt Nam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Điện thoại:</strong> 0359.951.5131 (Phước)
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Văn Phòng Chính - Top Fitness Center:</strong>
                <br />
                227 - 229 Hà Huy Giáp, Phường Thạnh Lộc, Quận 12
              </p>
            </div>
          </div>
        ) : (
          <div className="container term">
            <div className="intro">
              <h2>POLICIES & TERMS OF SERVICE</h2>
              <p>Applicable to all customers in Vietnam</p>
              <p>
                Hai Phuoc Co., Ltd - Official Distributor of Anovator A5 Body
                Composition Analyzer
              </p>
            </div>
            <h2>4. TERMS OF SERVICE</h2>
            <p>
              ⚖️{" "}
              <strong>Transparent Transactions – Clear Responsibilities</strong>
            </p>
            <p>
              By accessing our website or purchasing products, you agree to the
              following terms:
            </p>

            <h4>📝 Transaction Terms:</h4>
            <ul>
              <li>
                Orders are valid only when full details are provided and payment
                is successful
              </li>
              <li>
                We reserve the right to cancel orders with incorrect,
                fraudulent, or policy-violating information
              </li>
            </ul>

            <h4>🛠️ Product Usage:</h4>
            <ul>
              <li>
                Follow the provided User Manual for safe and optimal operation
              </li>
              <li>
                Unauthorized disassembly or technical interference may void the
                warranty
              </li>
            </ul>

            <h4>🔧 Our Commitment:</h4>
            <ul>
              <li>
                Provide genuine products with complete documentation and
                nationwide warranty
              </li>
              <li>
                Offer dedicated technical support before, during, and after
                purchase
              </li>
              <li>
                Handle complaints transparently based on mutual benefit
                principles
              </li>
            </ul>
            <div className="contact-info support">
              <h2>SUPPORT CONTACT INFORMATION</h2>
              <p>
                Hai Phuoc Co., Ltd – Official Distributor of Anovator in Vietnam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Phone:</strong> 0989.499.889
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Head Office - Top Fitness Center:</strong>
                <br />
                227 - 229 Ha Huy Giap Street, Thanh Loc Ward, District 12
              </p>
            </div>
          </div>
        )}

        <Footer />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Term));
